/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';

/**
 * Global configuration
 */
@Injectable({
  providedIn: 'root',
})
export class MDIApiConfiguration {
  rootUrl: string = '';
}

/**
 * Parameters for `MDIModule.forRoot()`
 */
export interface MDIApiConfigurationParams {
  rootUrl?: string;
}
